// extracted by mini-css-extract-plugin
module.exports = {"aside":"Top_aside__rqeaY","artist_names":"Top_artist_names__39DIq"};